import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { BoutAttribute } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get and save BoutAttribute data.
 */
@Injectable()
export class BoutAttributeService {
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Add or update the BoutAttribute
     */
    public save(boutAttribute: BoutAttribute, includes: string[] = null): Observable<BoutAttribute> {
        let response: Observable<IJsonApiResponse>;
        const apiRequestUrl: string =
            this.getApiUrl(boutAttribute.eventId, boutAttribute.boutId, boutAttribute.id, includes);

        if (boutAttribute.id) {
            // Update existing BoutAttribute
            response = this.http.patch(apiRequestUrl, boutAttribute.serialize());
        } else {
            // Add a new BoutAttribute
            response = this.http.post(apiRequestUrl, boutAttribute.serialize());
        }

        return response
            .pipe(map((response: IJsonApiResponse) => (new BoutAttribute()).deserialize(response)));
    }

    /**
     * Delete the specified BoutAttribute.
     */
    public delete(boutAttribute: BoutAttribute): Observable<boolean> {
        const apiRequestUrl: string =
            this.getApiUrl(boutAttribute.eventId, boutAttribute.boutId, boutAttribute.id, null);
        return this.http.delete(apiRequestUrl).pipe(map(() => true));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(
        eventId: string,
        boutId: string,
        boutAttributeId: string,
        includes: string[],
        queryParams: string[] = null,
    ): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/events/${eventId}/bouts/${boutId}/attributes/`;

        if (boutAttributeId) {
            url += boutAttributeId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
